import KabanIcon from "app/components/Icons/KabanIcon";
import ListIcon from "app/components/Icons/ListIcon";
import Spinner from "app/components/Icons/Spinner";
import IconText from "app/components/IconText";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CopyButton from "../../../components/CopyButton";
import { handleCopyBoardLink } from "../../../helpers";
import { actions as appActions } from "app/redux/slice";
import {
  selectFavorites,
  selectIsLoading,
  selectQaBoards,
  selectRecent,
} from "../../../redux/selector";
import { BoardViewType } from "app/types";
import CircularLoader from "app/components/CircularLoader";
import { Board } from "../../../types";

export default function Cards() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recent = useSelector(selectRecent);
  const favorites = useSelector(selectFavorites);
  const qaBoards = useSelector(selectQaBoards);
  const loading = useSelector(selectIsLoading);
  const items = [
    {
      title: "Recent",
      boards: recent,
    },
    {
      title: "Favorites",
      boards: favorites,
    },
    {
      title: "QA boards",
      boards: qaBoards,
    },
  ];
  const getBoardIcon = (type: BoardViewType) => {
    return type === BoardViewType.LIST ? (
      <ListIcon color="#79808A" />
    ) : (
      <KabanIcon color="#79808A" />
    );
  };
  const handleRedirectToBoard = (board: Board) => {
    dispatch(
      appActions.updateBoardOrderFromHome({
        board,
      }),
    );
    const base = `/app/${params.project}/${params.team}/boards/${board._id}`;
    const path = `${base}/${board?.viewType}/board`;
    navigate(path);
  };
  return (
    <div className="grid grid-cols-3 gap-4 mb-4 px-[24px]">
      {items?.length > 0 &&
        items?.map((item) => (
          <div
            key={item?.title}
            className="flex flex-col py-6 bg-white rounded-[4px] border-[1px] border-[#E9ECF2]"
          >
            <div className="px-6">
              <h5 className="font-medium text-black leading-[24px]">
                {item?.title}
              </h5>
            </div>
            {loading ? (
              <div className="w-full flex flex-col items-center justify-center h-[160px]">
                <CircularLoader size="md" />
              </div>
            ) : item?.boards?.length > 0 ? (
              <div className="w-full flex flex-col h-[160px] mt-[12px] overflow-y-auto px-[10px]">
                {item?.boards.map((board) => (
                  <div
                    key={board?._id}
                    onDoubleClick={() => handleRedirectToBoard(board)}
                    className="group flex items-center justify-between flex-row gap-[4px] py-2 hover:bg-[#F4F5F7] px-[14px] rounded-[4px]"
                  >
                    <div className="flex-1 min-w-0 max-w-[200px]">
                      <IconText
                        text={board?.name}
                        icon={getBoardIcon(board?.viewType)}
                        isTruncate={true}
                        className="text-secondary leading-[21px] text-sm max-w-[368px]"
                      />
                    </div>
                    <CopyButton
                      copyText={board?.name}
                      onClick={() =>
                        handleCopyBoardLink(
                          board,
                          params?.project,
                          params?.team,
                        )
                      }
                      className="opacity-0 group-hover:opacity-100"
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full flex flex-col items-center justify-center h-[160px]">
                <p className="text-secondary leading-[21px] text-center text-sm">
                  There are no any boards
                </p>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}
